if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-description-toggle]');
        if (!this.toggle) return;

        this.excerpt = this.querySelector('[data-description-excerpt]');
        this.full = this.querySelector('[data-description-full]');
        this.moreLabel = this.querySelector('[data-description-label-more]');
        this.lessLabel = this.querySelector('[data-description-label-less]');

        this.toggle.addEventListener('click', () => {
          const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
          this.setExpanded(!expanded);
        });
      }

      setExpanded(expanded) {
        this.toggle.setAttribute('aria-expanded', expanded);
        this.excerpt.hidden = expanded;
        this.full.hidden = !expanded;
        this.moreLabel.hidden = expanded;
        this.lessLabel.hidden = !expanded;
      }
    }
  );
}
